var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-inventory-po","size":"xl","title":"Pilih Inventory","hide-footer":""}},[_c('Table',{attrs:{"purpose":"modal","secondPurpose":"inventory-purchase-order","selectedItem":_vm.selectedItem,"checkbox":_vm.checkbox},on:{"checkItem":_vm.checkItem}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }